import { Alert, Fade, Modal, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getObservationsByObsPeriod } from "../../services";
import { useTranslation } from "react-i18next";
import globals from "../../globalConstants";
import LoadingSpinner from "../../globalComponents/LoadingSpinner";

const ObservationPeriod = ({ obsPeriod, open, handleClose }) => {

  const useStyles = makeStyles((theme) => ({
    modal: {
      display: "flex",
      padding: theme.spacing(1),
      alignItems: "center",
      justifyContent: "center",
      outline: "none",
    },
    paper: {
      backgroundColor: "white",
      height: "85%",
      width: "85%",
      padding: theme.spacing(2, 4, 3),
      overflowY: "scroll",
      overflowX: "hidden",
    },
    root: {
      "& .MuiFormControl-root": {
        width: "70%",
        margin: "1em"
      }
    },
  }));


  const { t } = useTranslation();
  const classes = useStyles();

  const [observations, setObservations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const retrieveObservations = async (id) => {
      setLoading(true);
      setFetchError(false);

      try {
        const res = await getObservationsByObsPeriod(id);
        if (cancelled) {
          return;
        }
        setObservations(res);
      } catch (e) {
        if (cancelled) {
          return;
        }
        console.error(e);
        setFetchError(true);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    if (obsPeriod?.id) {
      retrieveObservations(obsPeriod.id);
    }

    return () => {
      cancelled = true;
    };
  }, [obsPeriod?.id]);

  if (!obsPeriod) return <div>{t("observationPeriodNotDefined")}</div>;

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <h2 id="transition-modal-title">{t("observations")}</h2>
          <h3>{obsPeriod.location}, klo {obsPeriod.startTime} - {obsPeriod.endTime}</h3>

          {loading ? (
            <LoadingSpinner size="small" />
          ) : fetchError ? (
            <Alert severity="error">
              {t("observationsFetchFailed")}
            </Alert>
          ) : (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t("species")}</TableCell>
                  <TableCell>{t("count")}</TableCell>
                  <TableCell>{t("direction")}</TableCell>
                  <TableCell>{t("bypassSide")}</TableCell>
                  <TableCell>{t("notes")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {observations.map((s, i) =>
                  <TableRow key={i}>
                    <TableCell>{s.species}</TableCell>
                    <TableCell>{s.count}</TableCell>
                    <TableCell>
                      {globals.inverseDirections.get(s.direction)}, {s.direction}&#176;
                    </TableCell>
                    <TableCell>{globals.inverseBypass.get(s.bypassSide)}</TableCell>
                    <TableCell>{s.notes}</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          )}
        </div>
      </Fade>
    </Modal>

  );
};

ObservationPeriod.propTypes = {
  obsPeriod: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  periodId: PropTypes.string,
  handleErrorSnackOpen: PropTypes.func.isRequired,
};

export default ObservationPeriod;
